import { useBreakpointValue } from '@vimeo/bokeh';

import { playerGridSizeMap, thumbnailGridSizeMap } from '../utils/constants';
import { GetResponsiveValue, GridSize } from '../utils/types';

interface Props {
  getResponsiveValue: GetResponsiveValue;
  gridSize?: GridSize;
  isMobilePreview?: boolean;
  showVideoPlayerCards?: boolean;
  isNewCustomizeControls: boolean;
}

export const useVideoGrid = ({
  getResponsiveValue,
  gridSize = 's',
  isMobilePreview,
  showVideoPlayerCards,
  isNewCustomizeControls,
}: Props) => {
  // Determine the grid size to preview
  const effectiveGridSize = showVideoPlayerCards && gridSize === 's' ? 'm' : gridSize;
  const gridSizeMap = showVideoPlayerCards ? playerGridSizeMap : thumbnailGridSizeMap;
  const gridSizeConfig = gridSizeMap[effectiveGridSize];

  // Calculate columns
  const mobilePreviewGridColumns = gridSizeConfig.base;
  const customizationGridSizeColumns = useBreakpointValue(gridSizeConfig);
  const gridColumns = isMobilePreview ? mobilePreviewGridColumns : customizationGridSizeColumns;
  const numColumns = isNewCustomizeControls ? gridColumns : showVideoPlayerCards ? 3 : undefined;

  // Calculate gap
  const gridGap =
    showVideoPlayerCards || isNewCustomizeControls
      ? 'lg'
      : getResponsiveValue({ base: '0', sm: 'lg' });

  return { effectiveGridSize, gridGap, numColumns };
};
